import { useEmitterListener } from "@ryde/redux";
import { GlobalAppEventEnum } from "@ryde/shared";

import { usePassengerMapStations } from "./use-passenger-map-stations";

/**
 * A station created while this map is open, but not by its own add-station panel — "Add station here" in
 * place info — goes on the map at once and highlighted, as the panel's do, instead of after a reload.
 */
export const usePassengerMapCreatedStations = (): void => {
  const { showAddedStation } = usePassengerMapStations();

  useEmitterListener({
    event: GlobalAppEventEnum.STATION_CREATED,
    handler: showAddedStation,
  });
};
